export interface PrecomputedSortableColumn {
  field: string
  label: string
}

export const GDELT_SORTABLE_COLUMNS: PrecomputedSortableColumn[] = [
  { field: "impact_score", label: "Impact" },
  { field: "cluster_count", label: "Source" },
  { field: "publish_time", label: "Latest Member Published" },
  { field: "disease", label: "Disease" },
  { field: "resolved_location", label: "Location" },
  { field: "title", label: "Latest Member Title" },
]

export const NWSS_SORTABLE_COLUMNS: PrecomputedSortableColumn[] = [
  { field: "publish_time", label: "Last Detection" },
  { field: "cluster_count", label: "Source" },
  { field: "disease", label: "Disease" },
  { field: "resolved_location", label: "Location" },
  { field: "title", label: "Description" },
]

export const GDELT_SORTABLE_FIELDS = new Set(
  GDELT_SORTABLE_COLUMNS.map(column => column.field)
)

export const NWSS_SORTABLE_FIELDS = new Set(
  NWSS_SORTABLE_COLUMNS.map(column => column.field)
)
